import React from "react";
import { useTranslation } from "react-i18next";
import NutrientsChart from "./NutrientsChart";
import { getDisplayDate } from "../../../../utils/date-helpers";

const NutritionPlanChart = ({ planStats }) => {
  const { t } = useTranslation("athlete-portal");
  const { startDate, endDate, restDay, notes } = planStats;

  return (
    <div className="np-plan-card">
      <p className="np-plan-card__title">
        {t("nutritionPage.planChart.plan")}
      </p>

      <p className="np-plan-card__subtitle">
        {getDisplayDate(startDate, true)} {t("nutritionPage.history.to")}{" "}
        {getDisplayDate(endDate, true)}
      </p>

      {restDay ? (
        <div className="np-plan-card__rest-day-charts">
          <div className="np-plan-card__day-chart">
            <h5>{t("nutritionPage.planChart.trainingDay")}</h5>
            <NutrientsChart
              key={"nutrition-plan-summary-chart"}
              dayStats={planStats}
              height={250}
              width={250}
              providedId={"nutrition-plan-summary-chart-training-day-xd"}
              detailedLegend
            />
          </div>

          <div className="np-plan-card__day-chart">
            <h5>{t("nutritionPage.planChart.restDay")}</h5>
            <NutrientsChart
              key={"nutrition-plan-summary-chart"}
              dayStats={{ nutrients: { ...restDay } }}
              height={250}
              width={250}
              providedId={"nutrition-plan-summary-chart-rest-day-xd"}
              detailedLegend
            />
          </div>
        </div>
      ) : (
        <NutrientsChart
          key={"nutrition-plan-summary-chart"}
          dayStats={planStats}
          height={250}
          providedId={"nutrition-plan-chart-xd"}
          detailedLegend
        />
      )}

      {notes && (
        <>
          <p className="np-plan-card__notes-label">
            {t("nutritionPage.planChart.notes")}
          </p>
          <div className="np-plan-card__notes">
            <p className="p4">{notes}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default NutritionPlanChart;
